import { render, staticRenderFns } from "./PaySbpInvoice.vue?vue&type=template&id=292dbd0e&"
import script from "./PaySbpInvoice.vue?vue&type=script&lang=js&"
export * from "./PaySbpInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports